import { Injectable } from '@angular/core';

import { RestTicketModel } from '@shared/interfaces/turnover.interface';

import { RestapiService } from './restapi.service';

@Injectable({
  providedIn: 'root',
})
export class PunchService {
  constructor(private restApiService: RestapiService) {}

  loadPunchById(punchId: number) {
    return this.restApiService.getData<RestTicketModel>(`PunchTickets/${punchId}`);
  }

  loadPunchesByTurnoverId(turnoverId: string) {
    return this.restApiService.getData<RestTicketModel[]>(`PunchTickets/ByTurnoverId/${turnoverId}`);
  }

  createPunch(punch: RestTicketModel) {
    return this.restApiService.create<RestTicketModel>(`PunchTickets`, punch);
  }

  updatePunch(punch: RestTicketModel) {
    return this.restApiService.update<RestTicketModel>(`PunchTickets/${punch.id}`, punch);
  }
}
